var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"flat":"","color":"transparent"}},[_c('v-img',{staticClass:"img-caminhao",attrs:{"src":require("../../assets/caminhaov02.png"),"contain":"","width":_vm.width}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }